import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { UtilsService } from 'src/app/services';

@Component({
  selector:    'app-copy-to-clipboard',

  templateUrl: './copy-to-clipboard.component.html',
  styleUrls:   ['./copy-to-clipboard.component.scss']
})
export class CopyToClipboardComponent implements AfterViewInit {
  @Input() data: any;

  @Input() targetEl: Element;

  @ViewChild('copyEl') copyEl: ElementRef;

  constructor(public renderer: Renderer2, public utilsService: UtilsService) {
  }

  ngAfterViewInit(): void {
    if (this.targetEl) {
      this.renderer.listen(this.targetEl, 'mouseover', () => {
        if (this.copyEl) {
          this.renderer.setStyle(this.copyEl.nativeElement, 'display', 'inherit');
        }
      });
      this.renderer.listen(this.targetEl, 'mouseout', () => {
        if (this.copyEl) {
          this.renderer.setStyle(this.copyEl.nativeElement, 'display', 'none');
        }
      });
    }
  }

  copy() {
    this.utilsService.copy(this.data);
  }
}
